<ng-container *ngIf="isPDP; else PlpTemplate">
  <ng-container *ngIf="!isProductNotFound">
    <app-product-detail-view
      [routeParam]="routeParamMap$ | async"
      [currencyConfig]="currencyConfiguration$ | async"
      [productId]="productId"
      [position]="position"
      (productNotFound)="showProductNotFound($event)"
    ></app-product-detail-view>
  </ng-container>
  <ng-container *ngIf="isProductNotFound">
    <tvb-page-not-found [send404Response]="true"></tvb-page-not-found>
  </ng-container>
</ng-container>

<ng-template #PlpTemplate>
  <ng-container *ngIf="is404">
    <tvb-page-not-found [send404Response]="false"></tvb-page-not-found>
  </ng-container>

  <ng-container *ngIf="!is404">
    <div class="container">
      <ng-container *ngIf="title">
        <div class="bread-crumb-box">
          <a routerLink="/">{{ 'Home' | translate }}</a>
          <div class="chevron-forward">&nbsp;</div>
          <span class="text">{{ title | translate | catalogDictionary | titlecase }}</span>
        </div>
      </ng-container>
      <h1>{{ title | translate }}</h1>
      <ng-container *ngIf="description">
        <div class="description" [innerHTML]="description | translate"></div>
      </ng-container>
    </div>

    <ng-container>
      <tvb-listing-view-elk
        (outputCall)="removeTag($event)"
        (pageNotFound)="showPageNotFound($event)"
        [filter]="filter"
        [numOfNotLazyProdImages]="5"
      ></tvb-listing-view-elk>
    </ng-container>
    <div class="container">
      <h1>{{ subTitle | translate }}</h1>
      <ng-container *ngIf="subDescription">
        <div class="description" [innerHTML]="subDescription"></div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
